import { SAVE_USERBREIF, SAVE_ACTIVITY, SAVE_MEDIA_ACCOUNT, SAVE_ROUTER, SAVE_USERINFO, SAVE_NOTICE } from './mutation-types.js';
import { setSessionStore, getSessionStore } from 'Libs/sessionStorage.js';
import { setLocalStore} from 'Libs/localStorage.js';
export default {
    // 保存用户信息
    [SAVE_USERBREIF] (state, userInfo) {
        state.userInfo = userInfo;
        // 保存在回话中，刷新初始化state时可用
        state.status.login = true;
    },
    [SAVE_USERINFO] (state, userInfo) {
        state.realUserInfo = userInfo;
        // 保存在回话中，刷新初始化state时可用
        state.status.login = true;

        if(userInfo.roleId == 40){
            location.hash = "#/center/white";
        }
    },
    [SAVE_ACTIVITY] (state, auth) {
        state.activity = auth;
        console.log(state.activity);
        // 保存在回话中，刷新初始化state时可用
        state.status.allowAccess = true;
    },
    [SAVE_MEDIA_ACCOUNT] (state, mediaAccounts) {
        let change = getSessionStore('mediaChange');
        if(change){
            setSessionStore('mediaChange', ++change)
        }else{
            setSessionStore('mediaChange', 0)
        }
        state.mediaAccounts = mediaAccounts;
        setLocalStore('mediaAccounts', mediaAccounts);
    },
    [SAVE_ROUTER] (state, route) {
        state.curRouter = route;
    },
    [SAVE_NOTICE] (state, list) {
        state.noticeList = list;
    },
    setMediaDistributeInfo: (state, covers) =>{
        state.mediaDistributeCovers = covers;
    },
    setMediaDistributeData: (state, mediaInfo) =>{
        Object.assign(state.mediaDistributeData, mediaInfo);
    },
    setReportNum: (state, reportNum) => {
        state.reportNum++;
        console.log(state.reportNum);
    },
    getAuth: (state, data) => {
        state.hasAuth = data ? true : false
    }
}
